
// import React, { useEffect, useRef, useState } from 'react';
// import ReactPlayer from 'react-player';
// import './Home.css';

// const VideoPlayer = () => {
//   const playerRef = useRef(null); // Change the ref to refer to the player
//   const [videoUrl, setVideoUrl] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isFullScreen, setIsFullScreen] = useState(false);
//   const fallbackUrl = "https://cdn-out1-los1.ceflixcdn.com/lsdcstream/play1/playlist.m3u8"; // Fallback video URL


// const handleFullScreen = () => {
//     // Get the internal player (HTML5 video element)
//     const videoElement = playerRef.current.getInternalPlayer();
//     if (videoElement) {
//       if (videoElement.requestFullscreen) {
//         videoElement.requestFullscreen();
//       } else if (videoElement.mozRequestFullScreen) {
//         videoElement.mozRequestFullScreen();
//       } else if (videoElement.webkitRequestFullscreen) {
//         videoElement.webkitRequestFullscreen();
//       } else if (videoElement.msRequestFullscreen) {
//         videoElement.msRequestFullscreen();
//       }
//       setIsFullScreen(true);
//     }
//   };

//   const fetchVideoUrl = async () => {
//     try {
//       const response = await fetch('https://api.stdl.site/videos');
//       if (!response.ok) {
//         throw new Error('Failed to fetch video data');
//       }

//       const videos = await response.json();
//       if (videos.length > 0) {
//         const firstVideoUrl = videos[0].videoUrl;
//         // Check if the video URL ends with .mp4
//         if (firstVideoUrl.endsWith('.mp4')) {
//           setVideoUrl(firstVideoUrl);
//         } else {
//           setVideoUrl(null); // Set to null if not .mp4 so that the fallback will be used
//         }
//         setLoading(false);
//       } else {
//         console.log('No videos found');
//         setVideoUrl(null); // No data, fallback to the default video
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error('Error fetching video data:', error);
//       setVideoUrl(null); // On error, fallback to the default video
//     }
//   };

//   useEffect(() => {
//     fetchVideoUrl();
//   }, []);

//   return (
//     <div>   
//     <div className="player-wrapper">     
//       {videoUrl ? (
//         <ReactPlayer
//           ref={playerRef} // Use the ref for ReactPlayer
//           url={videoUrl}
//           controls
//           playing
//           width="100%"
//           height="100%"
//           config={{
//             file: {
//               attributes: {
//                 disablePictureInPicture: true,
//                 controlsList: "nodownload",
//               },
//             },
//           }}
//         />
//       ) : (
//         <ReactPlayer
//           ref={playerRef} // Use the ref for ReactPlayer
//           url={fallbackUrl} // Use the fallback URL if no valid .mp4 video
//           controls
//           playing
//           width="100%"
//           height="100%"
//           controlsList="nodownload" // Prevents the download button
//         />
//       )}
//       </div>
//       <div className='container'>
//       {!videoUrl && (
//         <button onClick={handleFullScreen} style={{ marginTop: '10px', padding: '10px', cursor: 'pointer' }}>
//           {isFullScreen ? 'Full Screen' : 'Full Screen'}
//         </button>
//       )}
      
//         {/* <div className='logotv'>
//           <img
//             src="http://162.210.199.3/Media/Hyperlink/LINK/iexcel.png"
//             alt="Program Banner"
//             className="small-image"
//           />
//           <h2 className="ixl">TV</h2>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default VideoPlayer;

//drag
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import './Home.css';

const VideoPlayer = () => {
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  const timeoutRef = useRef(null); // Ref to store our inactivity timer
  
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [showButton, setShowButton] = useState(true); // State to toggle button visibility
  
  // const fallbackUrl = "https://cdn-out1-los1.ceflixcdn.com/lsdcstream/play1/playlist.m3u8";
  const fallbackUrl = "https://vcpout-sf01-altnetro.internetmultimediaonline.org/cpdpstream/play1/playlist.m3u8";


  // https://vcpout-sf01-altnetro.internetmultimediaonline.org/cpdpstream/play1/playlist.m3u8
  const fetchVideoUrl = async () => {
    try {
      const response = await fetch('https://api.stdl.site/videos');
      if (!response.ok) throw new Error('Failed to fetch video data');

      const videos = await response.json();
      if (videos.length > 0) {
        const firstVideoUrl = videos[0].videoUrl;
        setVideoUrl(firstVideoUrl.endsWith('.mp4') ? firstVideoUrl : null);
        setLoading(false);
      } else {
        setVideoUrl(null);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching video data:', error);
      setVideoUrl(null);
    }
  };

  useEffect(() => {
    fetchVideoUrl();
  }, []);

  // Timer logic to hide the button after 3 seconds of inactivity
  const resetActivityTimer = () => {
    setShowButton(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    
    timeoutRef.current = setTimeout(() => {
      setShowButton(false);
    }, 3000); // 3 seconds
  };

  // Start the timer when the component mounts
  useEffect(() => {
    resetActivityTimer();
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  // Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      const isFull = !!(
        document.fullscreenElement || 
        document.webkitFullscreenElement || 
        document.mozFullScreenElement
      );
      setIsFullscreen(isFull);
      resetActivityTimer(); // Wake up button when fullscreen changes
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const toggleFullscreen = (e) => {
    e.stopPropagation(); // Prevent the click from immediately triggering other wrapper events
    if (!isFullscreen) {
      if (containerRef.current.requestFullscreen) {
        containerRef.current.requestFullscreen();
      } else if (containerRef.current.webkitRequestFullscreen) {
        containerRef.current.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  const currentVideoUrl = videoUrl || fallbackUrl;

  return (
    <div 
      className="player-wrapper" 
      ref={containerRef}
      // Attach activity listeners to the wrapper to catch taps/clicks/mouse moves
      onMouseMove={resetActivityTimer}
      onTouchStart={resetActivityTimer}
      onClick={resetActivityTimer}
    >
      {loading ? (
        <div className="video-loading">Loading video...</div>
      ) : (
        <>
          <ReactPlayer
            ref={playerRef}
            url={currentVideoUrl}
            controls
            playing
            width="100%"
            height="100%"
            config={{
              file: {
                attributes: {
                  playsInline: true,
                  webkitplaysinline: true,
                  disablePictureInPicture: true,
                  controlsList: "nodownload nofullscreen", 
                },
              },
            }}
          />
          
          {/* Custom Fullscreen Button with dynamic opacity class */}
          <button 
            className={`custom-fullscreen-btn ${showButton ? 'visible' : 'hidden'}`} 
            onClick={toggleFullscreen}
          >
            {isFullscreen ? (
              <svg viewBox="0 0 24 24" width="24" height="24" fill="white"><path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/></svg>
            ) : (
              <svg viewBox="0 0 24 24" width="24" height="24" fill="white"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
            )}
          </button>
        </>
      )}
    </div>
  );
};

export default VideoPlayer;

//https://cdn-out1-los1.ceflixcdn.com/lsdcstream/play1/playlist.m3u8
//https://cdn1.kingschat.online/uploads/media/539751b173312e097dc50b00/K2VWS0pVT09aeW1YcVdxai80c3NlQT09/Capacity_Lyrics_Video.mp4
  
// // export default Videoplayer;
// import React, { useEffect, useRef,useState } from 'react';
// // import Hls from 'hls.js';
// import './Home.css';
// const VideoPlayer = () => {
//   const videoRef = useRef(null);
//   const [videoUrl, setVideoUrl] = useState(null);
//   const [liveStreamUrl, setLiveStreamUrl] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isFullScreen, setIsFullScreen] = useState(false);

//   const handleFullScreen = () => {
//     if (videoRef.current) {
//       // Check if requestFullscreen is available and call it
//       if (videoRef.current.requestFullscreen) {
//         videoRef.current.requestFullscreen();
//       } else if (videoRef.current.mozRequestFullScreen) { // Firefox
//         videoRef.current.mozRequestFullScreen();
//       } else if (videoRef.current.webkitRequestFullscreen) { // Chrome, Safari and Opera
//         videoRef.current.webkitRequestFullscreen();
//       } else if (videoRef.current.msRequestFullscreen) { // IE/Edge
//         videoRef.current.msRequestFullscreen();
//       }
//     }
//   };
// //   useEffect(() => {
// //     if (Hls.isSupported() && videoUrl.includes(".m3u8")) {
// //       const hls = new Hls();
// //       hls.loadSource(videoUrl);
// //       hls.attachMedia(videoRef.current);
// //     } else if (videoUrl.includes(".mp4")) {
// //       videoRef.current.src = videoUrl;
// //     }
// //   }, [videoUrl]);


//   const fetchVideoUrl = async () => {
//     try {
//       const response = await fetch("http://162.210.199.3:3001/videos");
//       if (!response.ok) {
//         throw new Error("Failed to fetch video data");
//       }
  
//       const videos = await response.json();
//       console.log(videos);

//     //   setImage(videos[0].thumbnails)
//       if (videos.length > 0) {
//         const firstVideoUrl = videos[0].videoUrl;
//         // console.log(firstVideoUrl);
       
//         // Check if the URL ends with '.mp4'
//         if (firstVideoUrl.endsWith(".mp4")) {
//           setVideoUrl(firstVideoUrl); // Use the current video player
//         } else {
//           setVideoUrl(null); // Clear the existing video URL
//           setLiveStreamUrl(firstVideoUrl); // Use another player for live stream
//         }
  
//         setLoading(false);
//       } else {
//         console.log("No videos found");
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error("Error fetching video data:", error);
//     }
//   };
//   useEffect(() => {
//     fetchVideoUrl();
//   }, []);
//   return (
//     <div>
    
//       {liveStreamUrl  ? (
//         // Live stream video player (without controls)
//         <video
//       ref={videoRef}
//       src={liveStreamUrl}
//       controls={!videoUrl.includes(".m3u8")}
//       controlsList="nodownload"
//       style={{ width: '100%', height: '100%' }}
//     />

//       ) : (
//         // MP4 video player (with controls)
//         <video
//           src={videoUrl}
//           ref={videoRef}
//           autoPlay
//           muted
//           controls={true}
//           disablePictureInPicture
//           controlsList="nodownload"
//           style={{ width: '100%', height: '100%' }}
//         />
//       )}
//       {liveStreamUrl &&(
//         <button onClick={handleFullScreen} style={{ marginTop: '10px', padding: '10px', cursor: 'pointer' }}>
//         {isFullScreen ? "Exit Full Screen" : "Full Screen"}
//       </button>
//       )}
    

//     </div>
//   );
// };
// // videoUrl={videoUrl}
// export default VideoPlayer;
